<template lang="pug">
.row.g-0
  .col-md-2(v-if='sidebar')
    .ugo-mobile-filter.d-flex.d-md-none(
      @click='showFilter = !showFilter',
      :class='{ "is-active": showFilter }'
    )
      | ประเภท
      .rippleJS
    .ugo-series(:class='{ "is-active": showFilter }')
      //- h3.text-light(v-if="title") {{ title }}
      ul(v-if='this.parts')
        li(v-for='(item, index) in subcats', :key='item.term_id')
          a(
            :class='{ "is-active": item.term_id === parseInt($route.query.cat) }',
            @click='catSelect(item.term_id), (showFilter = false)'
          ) {{ item.name }}
      ul(v-else)
        li(v-for='(item, index) in subcats', :key='item.term_id')
          a(
            data-bs-toggle='collapse',
            :href='`#item-${index}`',
            :aria-controls='`item-${index}`',
            v-if='item.child.length > 0',
            @click='catSelect(item.term_id)'
          ) {{ item.name }}

          router-link(
            v-else,
            exact,
            :to='{ query: { cat: item.term_id, type: "subcat" } }',
            @click.native='showFilter = false'
          ) {{ item.name }}

          .collapse(:id='`item-${index}`', v-if='item.child.length > 0')
            ul
              li(v-for='child in item.child', :key='child.term_id')
                router-link(
                  :to='{ query: { cat: item.term_id, subcat: child.term_id, type: child.type, page: 1 } }',
                  :class='{ "is-active": child.term_id === parseInt($route.query.subcat) }',
                  exact,
                  @click.native='(page = 1), (showFilter = false)'
                ) {{ child.name }}

  div(:class='{ "col-md-10": sidebar, "col-md-12 pt-5": !sidebar }')
    header.ugo-header.d-flex(v-if='topbar')
      h2.ugo-series-title.d-none.d-xl-block(
        :class='{ "is-loading": loading }',
        v-if='subcatInfo.name',
        v-html='$options.filters.firstLetterBig(subcatInfo.name)'
      )
      .ugo-menu(:class='{ "no-title": !subcatInfo.name }')
        ul
          li 
            a(:href='golfcarurl', :class='{ "is-active": !cat || cat === 37 }') ทั้งหมด

          li(v-for='subcat in cats', :key='subcat.term_id')
            a(
              :class='{ "is-active": cat === subcat.term_id }',
              :href='subcat.link'
            ) {{ subcat.name }}

    .row.g-0.ugo-list(:class='{ "is-loading": loading }')
      .ugo-description.col-md-12(
        :class='{ "d-xl-none": !subcatInfo.description }',
        v-if='subcatInfo.description || subcatInfo.name'
      )
        h3.ugo-series-title.d-xl-none(v-if='subcatInfo.name') {{ subcatInfo.name }}
        div(v-if='subcatInfo.description', v-html='subcatInfo.description') 

      .product-col.col-md-4.col-6(v-for='item in products', :key='item.id')
        product-item(
          :item='item',
          :type='type === "subcategories" ? "2" : "default"'
        )

      .product-col.col-md-4.col-6(v-if='!products.length')
        p.text-center.pt-5 ไม่พบสินค้าในหมวดนี้ กรุณาเลือกหมวดอื่น

    pagination(
      :records='meta.total',
      v-model='page',
      :per-page='9',
      @paginate='pageChange',
      :options='options'
    )
</template>

<script>
import Collapse from 'bootstrap/js/src/collapse.js'
import axios from 'axios'
import ProductItem from './ProductItem.vue'
import Pagination from 'vue-pagination-2'

export default {
  components: { ProductItem, Pagination },

  props: {
    title: {
      type: String,
      default: '',
    },
    cat: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
    },
    topbar: {
      type: Boolean,
      default: true,
    },
    sidebar: {
      type: Boolean,
      default: true,
    },
    allTitle: {
      type: String,
      default: '',
    },
    parts: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showFilter: false,
      loading: false,
      description: null,
      products: [],
      meta: {
        total: 0,
      },
      cats: [],
      subcats: [],
      subcatInfo: {},
      golfcarurl: UGO.golfcarurl,
      page: 1,
      options: {
        edgeNavigation: true,
        chunk: 5,
        texts: {
          count:
            'Showing {from} to {to} of {count} items|{count} items|One item',
          first: 'first',
          last: 'last',
          nextPage: '›',
          nextChunk: '»',
          prevPage: '‹',
          prevChunk: '«',
        },
      },
    }
  },

  watch: {
    $route() {
      // this.fetchSubcat()
      this.fetchProduct()
    },
  },

  created() {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
  },

  mounted() {
    this.fetchCat()
    this.fetchSubcat()
    this.fetchProduct()

    // var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))
    // var collapseList = collapseElementList.map(function (collapseEl) {
    //   return new bootstrap.Collapse(collapseEl)
    // })
    // const items = document.querySelectorAll('.item5555')
    // items.forEach(element => {
    //   const bsCollapse = new Collapse(element, {
    //     toggle: false
    //   })
    // })
    const collapseElementList = [].slice.call(
      document.querySelectorAll('.collapse')
    )
    collapseElementList.map(function (collapseEl) {
      return new Collapse(collapseEl)
    })
  },

  methods: {
    fetchProduct() {
      this.loading = true
      axios
        .get(`${UGO.api.url}v1/product/search`, {
          params: {
            cat_id: this.cat ?? 37,
            per_page: 9,
            page: this.$route.query.page ? this.$route.query.page : this.page,
            cat: this.$route.query.cat,
            subcat: this.$route.query.subcat,
            parts: this.parts,
            subcat_type: this.$route.query.type,
          },
        })
        .then(({ data }) => {
          this.products = data.data
          this.meta = data.meta
          this.subcatInfo = data.subcat
          this.loading = false
        })
    },

    fetchCat() {
      axios
        .get(`${UGO.api.url}v1/product/cat`, {
          params: {},
        })
        .then(({ data }) => {
          this.cats = data.data
        })
    },

    fetchSubcat() {
      axios
        .get(`${UGO.api.url}v1/product/subcat`, {
          params: { parts: this.parts, cat_id: this.cat },
        })
        .then(({ data }) => {
          this.subcats = data.data
        })
    },

    catSelect(id) {
      this.page = 1
      if (this.parts) {
        this.$router.push({ query: { cat: id } })
      } else {
        this.$router.push({ query: { cat: id, type: 'subcat' } })
      }
    },
    pageChange(page) {
      document.querySelector('.woocommerce-breadcrumb').scrollIntoView()
      this.$router.push({
        query: {
          cat: this.$route.query.cat,
          subcat: this.$route.query.subcat,
          type: this.$route.query.type,
          page: page,
        },
      })
    },
  },
}
</script>
